import React from 'react';
import { FieldSelect, View } from '../../elements';
import theme, { hairline } from '../../Theme';
export const SectionSelect = ({ name, column, values, selectedValue, handleOnChange }) => {
    return (React.createElement(View, { style: Object.assign(Object.assign({}, hairline.top), { flex: 1, 
            // height: 60,
            backgroundColor: theme.color.traficWhite }), row: true, center: true, onClick: () => { } },
        React.createElement(FieldSelect, { name: name, column: column, value: selectedValue, options: values, onChange: handleOnChange })));
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/components/SectionSelect.tsx
// module id = 560
// module chunks = 0